import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prevent queries from causing white screens
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Don't throw errors to error boundary by default
      throwOnError: false,
    },
    mutations: {
      retry: 0,
      // Don't throw errors to error boundary by default
      throwOnError: false,
    },
  },
});
